<template>
  <div class="header__version">{{ version }}</div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'VersionIndicator',
    computed: {
      ...mapGetters('main', ['version']),
    },
  };
</script>
